module.exports = __webpack_public_path__ + "img/bar-green.c91cf87e.png";